import React from 'react'
import { Container } from 'react-bootstrap'
const Legal = () => {
  return (
    <div>
      <Container className='home'>
        <h3>legal stuff</h3>
      </Container>
    </div>
  )
}

export default Legal
